import SubTitle from '../components/elements/sub-title';
import Title from '../components/elements/title';
import UnorderedList from '../components/elements/unordered-list';
import { CONTACT_EMAIL } from '../constants';

export const PrivacyPolicyNl = () => {
  return (
    <div>
      <Title>Privacyverklaring</Title>
      <div className="my-2">Jouw privacy is belangrijk voor ons.</div>
      <p className="my-2">Laatst aangepast op 2 juni 2021</p>
      <SubTitle>Je persoonlijke gegevens</SubTitle>
      <div className="my-2">
        Je deelt ze met ons, zodat wij je optimaal van dienst kunnen zijn. We vinden het belangrijk dat jij ook weet
        waarom wij om je persoonlijke gegevens vragen en wat wij ermee doen. Hieronder vind je een uitleg van enkele
        redenen waarom we informatie van je vragen en op welke manier we deze van je verkrijgen en gebruiken. Lees dit
        Privacybeleid aandachtig door, want het bevat essentiële informatie over hoe uw persoonsgegevens worden verwerkt
        en welke cookies worden gebruikt. Waar we in dit Privacybeleid verwijzen naar ‘persoonsgegevens’, bedoelen we de
        informatie die jij aan ons verstrekt over jezelf, zoals je naam, adres, e-mailadres en telefoonnummer, maar ook
        producten die je hebt gekocht of bijvoorbeeld e-mails die je aan ons hebt gestuurd. Door het verstrekken van je
        persoonsgegevens, verklaar je kennis te hebben genomen van dit Privacybeleid en ga je er eveneens uitdrukkelijk
        mee akkoord, alsook met de verwerking zelf. Heb je na het lezen hiervan nog vragen, laat het ons dan weten via{' '}
        {CONTACT_EMAIL}
      </div>
      <SubTitle>Welke gegevens verzamelen we en waarom?</SubTitle>
      <div className="my-2">
        Je deelt gegevens met ons op verschillende manieren. Wij gebruiken daarbij gegevens die we van jou ontvangen
        hebben, maar ook door onszelf verzamelde gegevens. Bijvoorbeeld gegevens over je bezoek aan onze website. Je
        bent niet verplicht om jouw persoonsgegevens vrij te geven, maar begrijp dat het verlenen van bepaalde diensten
        onmogelijk wordt wanneer je de verwerking weigert. Je bent als enige verantwoordelijk voor de juistheid van die
        gegevens.
      </div>
      <div className="mt-4">
        Wij zullen de verzamelde persoonsgegevens uitsluitend voor de volgende doeleinden gebruiken:
      </div>
      <UnorderedList>
        <div>
          <div className="font-semibold">Anonieme gegevens</div>
          <div className="my-2">
            Dit zijn gegevens die je met ons deelt zonder registratie: IP-adres, surfgedrag, herkomst, zoektermen. We
            gebruiken deze gegevens voor het onderhouden en verbeteren van onze website. Dit houdt in dat we
            persoonsgegevens opnemen in anonieme statistieken, waaruit de identiteit van specifieke personen of
            bedrijven niet kunnen achterhaald worden, met als rechtsgrond de legitieme belangen van Gypsy de Saint
            Tropez om haar website en dienstverlening voortdurend te verbeteren.
          </div>
        </div>
        <div>
          <div className="font-semibold">Cookies</div>
          <div className="my-2">
            De website maakt ook gebruik van cookies die een aantal persoonsgegevens verzamelen met als rechtsgrond uw
            expliciete, voorafgaande toestemming. We gebruiken deze gegevens voor het onderhouden en verbeteren van onze
            website. Voor de bepalingen omtrent het gebruik van cookies, zie het cookie beleid.
          </div>
        </div>
        <div>
          <div className="font-semibold">Je account</div>
          <div className="my-2">
            Je kan op onze website een account aanmaken. In je account slaan we onder andere de volgende informatie op:
            je naam, adres(sen), telefoonnummer, e-mailadres, aflever- en betaalgegevens en opgegeven informatie en
            interesses. We houden dit bij, zodat je ze bij een volgend bezoek aan onze website of bij het plaatsen van
            een bestelling niet telkens opnieuw hoeft in te voeren. Daarnaast gebruiken we de opgegeven contactgegevens
            ook om je te contacteren bij vragen of opmerkingen over je bestelling of om jouw mening te vragen. Het
            beheer van jouw account op deze website heeft als rechtsgrond de uitvoering van een overeenkomst die door
            jou werd gevraagd. Je kan je account steeds annuleren.
          </div>
        </div>
        <div>
          <div className="font-semibold">Login via externe media</div>
          <div className="my-2">
            Als je een profiel hebt op externe media, zoals Facebook, Google, ... Kan je via jouw account inloggen bij
            Gypsy de Saint-Tropez. Wij nemen van je deze accounts enkel volgende gegevens over: naam, familienaam en
            e-mailadres. Zij kunnen de gegevens in je account niet bekijken. Je kan deze gegevens en je account steeds
            loskoppelen in je instellingen.
          </div>
        </div>
        <div>
          <div className="font-semibold">Online bestellen of reserveren</div>
          <div className="my-2">
            Voor je bestelling hebben we je naam, e-mailadres, adres(sen), betaalgegevens en je telefoonnummer nodig.
            Deze hebben we nodig voor de levering en facturatie van door jou bestelde producten, met als rechtsgrond het
            verstrekken van een dienst die door jou gevraagd werd. We gebruiken de gegevens om de bestelling te
            bezorgen, je op de hoogte houden over je bestelling of om je te contacteren bij vragen of opmerkingen over
            je bestelling. Indien je een bestelling plaatst en hiervoor gebruik maakt van je account (zie “je account”),
            registreren wij deze op naam. Deze gegevens worden gebruikt voor het maken van statistische en algemene
            analyses van je aankoopgedrag, alsook voor profiling doeleinden.
          </div>
        </div>
        <div>
          <div className="font-semibold">Fraude</div>
          <div className="my-2">
            Je betaalgegevens kunnen worden gebruikt voor het opsporen van fraude en andere onrechtmatigheden.
          </div>
        </div>
        <div>
          <div className="font-semibold">Inschrijven op de nieuwsbrief</div>
          <div className="my-2">
            Je kan je aanmelden voor onze verschillende nieuwsbrieven. Bij het inschrijven, vragen we je naam,
            e-mailadres, telefoonnummer, geboortedatum en interesses. Zo blijf je op de hoogte van acties, promoties en
            de nieuwste trends en kunnen we je uitnodigen op evenementen. We hebben algemene en persoonlijke
            nieuwsbrieven. De persoonlijke nieuwsbrieven stellen we samen op basis van je gegevens, zoals eerdere
            bestellingen, aankopen en surfgedrag. Hiervoor geldt steeds als rechtsgrond je expliciete, voorafgaande
            toestemming. Wil je geen nieuwsbrieven van ons meer ontvangen, dan kan je je steeds afmelden door de link te
            volgen onderaan de e-mail die je ontvangt.
          </div>
        </div>
        <div>
          <div className="font-semibold">Wie heeft toegang tot jouw persoonlijke gegevens?</div>
          <div className="my-2">
            Binnen Gypsy de Saint-Tropez, zijn de gegevens alleen toegankelijk voor verantwoordelijke personen die daar
            in functie van hun taken toegang toe moeten hebben.
          </div>
        </div>
        <div>
          <div className="font-semibold">Doorgifte aan derden</div>
          <div className="my-2">
            Occasioneel doen we een beroep op een externe verwerker om ons te helpen met bepaalde diensten. Deze
            diensten kunnen bestaan uit bezorgdiensten, het verwerken van credit/debitcard. Dit houdt onder meer in dat
            we voor bepaalde taken of onderzoeken tijdelijk persoonsgegevens doorgeven aan derden omdat zij die nodig
            hebben om de service aan jou, uit te kunnen voeren. We leggen dit steeds contractueel vast met deze
            verwerkers en beperken de gegevens die we delen met derden tot alleen de doeleinden waarvoor de ander ze
            nodig heeft. Zo zal deze verwerker je gegevens nooit op eigen initiatief mogen gebruiken en moeten je
            gegevens gewist worden van zodra die verwerker de opdracht heeft voltooid. Derde partijen worden streng
            gecontroleerd om er zeker van te zijn dat je privacy beschermd blijft.
          </div>
          <div className="my-2">
            Ook kunnen we in zeldzame gevallen je gegevens doorgeven als we daartoe verplicht worden door bepaalde wet-
            en regelgeving en/of rechtspraak. Het kan voorkomen dat wij uw persoonsgegevens ingevolge een gerechtelijk
            bevel of om te voldoen aan andere dwingende wet- of regelgeving moet onthullen. In dat geval zullen wij in
            redelijkheid pogen je van tevoren hierover te informeren, tenzij dit aan wettelijke beperkingen onderhevig
            is.
          </div>
          <div className="my-2">
            Gypsy de Saint-Tropez zal jouw persoonsgegevens niet verkopen, noch verhuren, verdelen anderszins
            commercieel ter beschikking stellen aan derden, behalve zoals bovenstaand beschreven of tenzij met jouw
            voorafgaande toestemming.
          </div>
        </div>
        <div>
          <div className="font-semibold">Bewaarperiode van uw gegevens</div>
          <div className="my-2">
            De persoonsgegevens worden door ons bewaard en verwerkt voor een periode die noodzakelijk is in functie van
            de doeleinden van de verwerking en in functie van de contractuele relatie tussen jou en Gypsy de
            Saint-Tropez.
          </div>
        </div>
      </UnorderedList>
      <SubTitle>Contacteer ons</SubTitle>
      <div>
        <p>Gypsy Mode</p>
        <p>BE.0830.868.445</p>
        <p>Jan Hijoensstraat 7</p>
        <p>8800 Roeselare</p>
        <p>België</p>
        <p>{CONTACT_EMAIL}</p>
      </div>
    </div>
  );
};
